import styles from './FeaturesLinksSection.module.scss';

import Link from 'gatsby-link';
import React from 'react';
import { Container } from 'reactstrap';
import RetinaImage from 'src/components/RetinaImage';
import {
  ScrollOverPack,
  TweenOne,
  FadeIn,
  FadeUp
} from 'src/components/Animations';

import IconAPI from 'src/images/icon-api.png';
import IconAPI2x from 'src/images/icon-api@2x.png';
import IconAPI3x from 'src/images/icon-api@3x.png';
import IconAuditing from 'src/images/icon-auditing.png';
import IconAuditing2x from 'src/images/icon-auditing@2x.png';
import IconAuditing3x from 'src/images/icon-auditing@3x.png';
import IconCarrierAgnostic from 'src/images/icon-carrier-agnostic.png';
import IconCarrierAgnostic2x from 'src/images/icon-carrier-agnostic@2x.png';
import IconCarrierAgnostic3x from 'src/images/icon-carrier-agnostic@3x.png';
import IconDashboard from 'src/images/icon-dashboard.png';
import IconDashboard2x from 'src/images/icon-dashboard@2x.png';
import IconDashboard3x from 'src/images/icon-dashboard@3x.png';
import IconOptimization from 'src/images/icon-optimization.png';
import IconOptimization2x from 'src/images/icon-optimization@2x.png';
import IconOptimization3x from 'src/images/icon-optimization@3x.png';
import IconReporting from 'src/images/icon-reporting.png';
import IconReporting2x from 'src/images/icon-reporting@2x.png';
import IconReporting3x from 'src/images/icon-reporting@3x.png';
import IconTeams from 'src/images/icon-teams.png';
import IconTeams2x from 'src/images/icon-teams@2x.png';
import IconTeams3x from 'src/images/icon-teams@3x.png';
import IconPayments from 'src/images/icon-payments.png';
import IconPayments2x from 'src/images/icon-payments@2x.png';
import IconPayments3x from 'src/images/icon-payments@3x.png';

export default (props) => (
  <ScrollOverPack {...props}
                  className={props.className}
                  styleName='features-links-section'>
      <TweenOne key='headings' component={Container} {...FadeIn}>
          <div key='heading' className='h2 text-center'>
              Explore our features
          </div>
          <div key='subheading' className='h2 text-blue text-center'>
              You&rsquo;ll like them.
          </div>
      </TweenOne>
      <TweenOne key='links-container' styleName='links-container' {...FadeUp}>
          <Link styleName='link-cell' to='/features/dashboard'>
              <div styleName='icon-container'>
                  <RetinaImage srcSet={[IconDashboard, IconDashboard2x, IconDashboard3x]} />
              </div>
              Dashboard
          </Link>
          <Link styleName='link-cell' to='/features/reporting'>
              <div styleName='icon-container'>
                  <RetinaImage srcSet={[IconReporting, IconReporting2x, IconReporting3x]} />
              </div>
              Reporting
          </Link>
          <Link styleName='link-cell' to='/features/auditing'>
              <div styleName='icon-container'>
                  <RetinaImage srcSet={[IconAuditing, IconAuditing2x, IconAuditing3x]} />
              </div>
              Auditing
          </Link>
          <Link styleName='link-cell' to='/features/optimization'>
              <div styleName='icon-container'>
                  <RetinaImage srcSet={[IconOptimization, IconOptimization2x, IconOptimization3x]} />
              </div>
              Optimization
          </Link>
          <Link styleName='link-cell' to='/features/carrier-agnostic'>
              <div styleName='icon-container'>
                  <RetinaImage srcSet={[IconCarrierAgnostic, IconCarrierAgnostic2x, IconCarrierAgnostic3x]} />
              </div>
              Carrier agnostic
          </Link>
          <Link styleName='link-cell' to='/features/payments'>
              <div styleName='icon-container'>
                  <RetinaImage srcSet={[IconPayments, IconPayments2x, IconPayments3x]} />
              </div>
              Payments
          </Link>
          <Link styleName='link-cell' to='/features/teams'>
              <div styleName='icon-container'>
                  <RetinaImage srcSet={[IconTeams, IconTeams2x, IconTeams3x]} />
              </div>
              Teams
          </Link>
          <Link styleName='link-cell' to='/features/api'>
              <div styleName='icon-container'>
                  <RetinaImage srcSet={[IconAPI, IconAPI2x, IconAPI3x]} />
              </div>
              API
          </Link>
      </TweenOne>
  </ScrollOverPack>
);



// WEBPACK FOOTER //
// ./src/components/FeaturesLinksSection.js